import { render, staticRenderFns } from "./ClearCache.vue?vue&type=template&id=c27267ac&scoped=true"
import script from "./ClearCache.vue?vue&type=script&lang=js"
export * from "./ClearCache.vue?vue&type=script&lang=js"
import style0 from "./ClearCache.vue?vue&type=style&index=0&id=c27267ac&prod&lang=less&scoped=true"
import style1 from "./ClearCache.vue?vue&type=style&index=1&id=c27267ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27267ac",
  null
  
)

export default component.exports